import { Flex, Icon, P, Space } from '@dnb/eufemia';
import { cloud as CloudIcon, hourglass as HourglassIcon, stop as StopIcon } from '@dnb/eufemia/icons';
import { Decision } from '@portals/shared/portal/AppApiEntitlementDto';
import type { ReviewStatusType, ScopeRequestDto } from '@portals/shared/portal/ScopeRequestDto';
import classNames from 'classnames';
import { useOutletContext } from 'react-router-dom';

import Card from '@/components/Card';
import Divider from '@/components/Divider';
import { humanDatetime } from '@/utils';

import { ApiProviderPageOutletContext } from '../../ApiProviderPage';
import ScopeRequestDelete from '../../ApiProviderPage/VisibilityAndAccessManagementTab/ScopeRequestSection/ScopeRequestDelete';

import style from './index.module.css';

type ScopeRequestCardProps = {
  scopeRequest: ScopeRequestDto;
  onSuccess: () => void;
};
const getIcon = (status: ReviewStatusType) => {
  switch (status) {
    case Decision.PENDING: {
      return <HourglassIcon />;
    }
    case Decision.APPROVED: {
      return <CloudIcon />;
    }
    case Decision.DENIED: {
      return <StopIcon />;
    }
    default: {
      return <HourglassIcon />;
    }
  }
};

export default function ScopeRequestCard({ scopeRequest, onSuccess }: ScopeRequestCardProps) {
  const { api, isTeamAdmin } = useOutletContext<ApiProviderPageOutletContext>();
  return (
    <Card>
      <Space bottom="small" className={style['Container']}>
        <div className={style['Container-Scope']}>
          <span className={classNames(style['Icon'], style[`Icon--${scopeRequest.reviewStatus.toLowerCase()}`])}>
            <Icon icon={getIcon(scopeRequest.reviewStatus)} />
          </span>
          <div className={style['Container-ScopeDetails']}>
            <P>{scopeRequest.scopeName}</P>
            <P size="x-small">{scopeRequest.scopeDescription}</P>
          </div>
        </div>
        <div className={classNames('grid grid-cols-[auto_auto] gap-x-2', style['Container-StatusType'])}>
          <P size="small">Status: </P>
          <P size="small">{scopeRequest.reviewStatus}</P>
          <P size="small">Type:</P>
          <P size="small">{scopeRequest.requestType}</P>
        </div>
      </Space>

      <Divider />
      <Space className={style['Container']}>
        <Flex.Horizontal align="baseline" justify="space-between" stretch>
          {scopeRequest.reviewStatus === Decision.DENIED && (
            <div>
              <P size="x-small">Reviewed: {humanDatetime(scopeRequest.reviewedAt)}</P>
              <P size="x-small">Reason: {scopeRequest?.reviewComment}</P>
            </div>
          )}
          <P size="x-small">Requested: {humanDatetime(scopeRequest.createdAt)}</P>
          {scopeRequest.reviewStatus === Decision.PENDING && isTeamAdmin && (
            <ScopeRequestDelete
              apiSlug={api.slug}
              onSuccess={onSuccess}
              requestType={scopeRequest.requestType}
              scopeName={scopeRequest.scopeName}
              scopeRequestId={scopeRequest.id}
            />
          )}
        </Flex.Horizontal>
      </Space>
    </Card>
  );
}
